export const XERO_INVOICE_DEFAULTS = {
  dueDateOffsetDays: 14,
  taxType: 'GST Free Income',
  currency: 'AUD'
}
